/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as VideoDefs from './defs.defs.js'

const $nsid = 'app.bsky.video.getUploadStatus'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  jobId: /*#__PURE__*/ l.string({ minLength: 1, maxLength: 256 }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  jobId: /*#__PURE__*/ l.string({ minLength: 1, maxLength: 256 }),
  partSizeBytes: /*#__PURE__*/ l.integer(),
  partCount: /*#__PURE__*/ l.integer(),
  receivedParts: /*#__PURE__*/ l.array(/*#__PURE__*/ l.integer({ minimum: 1 })),
  expiresAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  state: /*#__PURE__*/ l.string<{
    maxLength: 32
    knownValues: [
      'created',
      'finishing',
      'completed',
      'failed',
      'aborted',
      'expired',
    ]
  }>({ maxLength: 32 }),
  completedJobId: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ minLength: 1, maxLength: 256 }),
  ),
  jobStatus: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<VideoDefs.JobStatus>(
      (() => VideoDefs.jobStatus) as any,
    ),
  ),
  failureReason: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxLength: 1024 }),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get the authoritative status of the upload phase. Terminal states remain readable. completedJobId and jobStatus are present only for completed sessions; failureReason is present only for failed sessions. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['UploadNotFound'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
